import moment from 'moment'
import Vue from 'vue'

Vue.filter('adaptiveTime', function(value) {
    if (value) {
        const ref = moment().startOf('day');
        const date = moment(String(value));
        if (date.isSame(ref, 'd')) {
            return date.format('hh:mm')
        } else {
            return date.format('MM/DD/YYYY hh:mm')
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/filters/time.js